import React, { useEffect, useState } from "react";
import { Form, Card, Row, Spin, Col, Button, Image, notification } from "antd";
import { useLocation } from "react-router-dom";
import { ConfirmServices } from "./services/confirm-service";
import { useId24 } from "../../drivers/id24/Id24Provider";
import { LoadingOutlined } from "@ant-design/icons";
import { PolicyConfirm } from "./components/policy";
import { ConfirmEvent } from "./components/confirm";
import { SuccessEvent } from "./components/success";

import Logo from "../../assets/images/Logo_350.png";
import { loadAppConfig } from "../../configs/app-config";

type NotificationType = "success" | "info" | "warning" | "error";

const antIcon = <LoadingOutlined className="text-[24px]" spin />;

interface IUser {
  id: number;
  userId: string;
  numberId?: string;
  fullName: string;
  email: string;
  company: string;
  department: string;
  position: string;
  phone: string;
  qrcodeId: string;
  registerStatus: boolean;
  registerDate: string;
  agendaId: string;
  createDate: string;
  updateDate: string;
  qrCode: string;
}

export const MainEvent: React.FC = (): React.ReactElement => {
  const { id24Axios } = useId24();
  const apiBaseUrl = id24Axios(loadAppConfig().REACT_APP_API_BASE_URL);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const userId = params.get("userid");
  const agendaId = params.get("agendaid");
  const [form] = Form.useForm();
  const [loading, setLoading] = useState<boolean>(true);
  const [userData, setUserData] = useState<IUser>();
  const [currentStep, setCurrentStep] = useState<number>(0);

  useEffect(() => {
    ConfirmServices(apiBaseUrl)
      .getdatauserByagendaid(userId)
      .then((resultUser) => {
        setUserData(resultUser);
        setLoading(false);
        //   confirmServices.getdataagendaByagendaid(agendaId).then((resultAgenda) => {
        //     setMasterdataAgenda(resultAgenda);
        //     setLoading(false);
        //   });
      });
  }, [ userId]);

  const onChangeCurrentStep = (step: number) => {
    setCurrentStep(step);
  };

  const steps = [
    {
      key: 0,
      title: "policy",
      content: <PolicyConfirm />,
    },
    {
      key: 1,
      title: "confirmevent",
      content: <ConfirmEvent userData={userData} form={form} />,
    },
    {
      key: 2,
      title: "successevent",
      content: <SuccessEvent />,
    },
  ];

  const onsubmitform = () => {
    const body = {
      agendaId: agendaId,
      userId: userId,
      fullName: form.getFieldValue("fullName"),
      email: form.getFieldValue("email"),
      company: form.getFieldValue("company"),
      department: "",
      position: form.getFieldValue("position"),
      phone: form.getFieldValue("phone"),
      confirmStatus: true,
    };

    ConfirmServices(apiBaseUrl).confirmEvent(body).then((resultUser) => {
      if (resultUser.email) {
        openNotificationWithIcon("success");
      } else {
        openNotificationWithIcon("error");
      }
    });
    onChangeCurrentStep(currentStep + 1);
  };

  const openNotificationWithIcon = (type: NotificationType) => {
    if (type === "success")
      return notification[type]({
        message: "สำเร็จ",
        description: "กรุณานำ QR-Code ที่ได้รับจากอีเมลของท่านมาเพื่อเช็คอินเข้าร่วมงาน",
      });
    if (type === "error")
      return notification[type]({
        message: "ไม่สำเร็จ",
        description: "ขออภัย เนื่องจากอีเมลนี้มีการลงทะเบียนไปแล้ว",
      });
  };

  return loading ? (
    <Row>
      <Col offset={12}>
        <Spin indicator={antIcon} />
      </Col>
    </Row>
  ) : (
    <>
      <Card className="w-[webkit-fill-available] rounded-[20px] shadow-[rgba(0,0,0,0.15)_1.95px_1.95px_2.6px]">
        <div className="flex justify-center mb-2">
          <Image src={Logo} width={"70%"} preview={false} />
        </div>

        {steps.map(({ title, content }, i) => {
          return (
            <Col hidden={i === currentStep ? false : true} md={24} key={title}>
              {content}
            </Col>
          );
        })}
        <br></br>
        <Form.Item className="flex justify-center items-center">
          <Row gutter={[16, 16]}>
            {currentStep === 0 && (
              <Col>
                <Button className="rounded-md w-full">{`Decline`}</Button>
              </Col>
            )}
            {currentStep < steps.length - 1 && currentStep === 0 && (
              <Col>
                <Button className="text-white bg-[#005EA6] w-full rounded-md" onClick={() => onChangeCurrentStep(currentStep + 1)}>
                  {`Accept`}
                </Button>
              </Col>
            )}
            {currentStep > 0 && currentStep === 1 && (
              <Col>
                <Button className="rounded-md" onClick={() => onChangeCurrentStep(currentStep - 1)}>
                  {`Back`}
                </Button>
              </Col>
            )}
            {currentStep > 0 && currentStep === 1 && (
              <Col>
                <Button type="primary" className="rounded-md" onClick={onsubmitform}>
                  {`Confirm`}
                </Button>
              </Col>
            )}
          </Row>
        </Form.Item>
      </Card>
    </>
  );
};
